<template>
    <div>
        <input
            v-model="computedFilter"
            id="search-input"
            type="search"
            class="search__form-input form__input"
            name="search"
            autocomplete="off"
            placeholder="Search Here"
            @keyup.enter="registerGA(computedFilter, computedFilter)"
        />
        <p v-if="isLoading">Searching...</p>
        <div class="search__results-container">
            <div class="search__results">
                <div v-if="searchSuggestions && searchSuggestions.length">
                    <h2 class="search__results-heading">Suggested Searches</h2>
                    <div v-for="suggestion in searchSuggestions.slice(0, 3)" :key="suggestion.sUrl">
                        <a
                            :href="suggestion.sUrl"
                            class="search__results-result"
                            @click="registerGA(suggestion.url, suggestion.title)"
                        >
                            {{ suggestion.title }}
                        </a>
                    </div>
                </div>
                <div v-if="keywordChars >= 3 && (!searchSuggestions || !searchSuggestions.length)">
                    <h2 class="search__results-heading">Suggested Searches</h2>
                    <div>
                        <p>No matches found.</p>
                    </div>
                </div>
            </div>

            <!-- Recommended Searches -->
            <h2
                class="search__results-heading"
                v-if="recomWines.length || recomEvent.length || recomArchive.length || recomBackVintages.length"
            >
                Recommended Searches
            </h2>

            <div class="search__results" v-if="recomWines.length">
                <strong class="search__results-sub-heading">Wine Shop</strong>
                <div v-for="wine in recomWines" :key="wine.url">
                    <a
                        :href="wine.url"
                        class="search__results-result"
                        @click="registerGA(wine.url, wine.title)"
                    >
                        {{ wine.title }}
                    </a>
                </div>
            </div>

            <div class="search__results" v-if="recomEvent.length">
                <strong class="search__results-sub-heading">Events</strong>
                <div v-for="event in recomEvent" :key="event.url">
                    <a
                        :href="event.url"
                        class="search__results-result"
                        @click="registerGA(event.url, event.title)"
                    >
                        {{ event.title }}
                    </a>
                </div>
            </div>

            <div class="search__results" v-if="recomArchive.length">
                <strong class="search__results-sub-heading">Pages</strong>
                <div v-for="archive in recomArchive" :key="archive.url">
                    <a
                        :href="archive.url"
                        class="search__results-result"
                        @click="registerGA(archive.url, archive.title)"
                    >
                        {{ archive.title }}
                    </a>
                </div>
            </div>

            <div class="search__results" v-if="recomBackVintages.length">
                <strong class="search__results-sub-heading">Back Vintages</strong>
                <div v-for="bv in recomBackVintages" :key="bv.url">
                    <a
                        :href="bv.url"
                        class="search__results-result"
                        @click="registerGA(bv.url, bv.title)"
                    >
                        {{ bv.title }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { actions, getters } from "../search";

import debounce from 'lodash/debounce';

export default {
  name: "search",
  props: {
    filter: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localFilter: this.filter, // Internal state for the input
      abortController: new AbortController(),
      debouncedFilterChange: null, // Placeholder for the debounced function
    };
  },
  watch: {
    filter(newVal) {
      this.localFilter = newVal;
    },
  },
computed: {
  computedFilter: {
    get() {
      console.log("Getter called. Current filter:", this.filter);
      return this.filter; // Value passed from the parent
    },
    set(value) {
      console.log("Setter called. New filter:", value);
      this.$emit("update:filter", value); // Notify parent
      this.handleFilterChange(value); // Trigger search logic
    },
  },

    searchSuggestions() {
      return getters.searchSuggestions();
    },
    keywordChars() {
      return getters.keywordChars();
    },
    recomWines() {
      return getters.recomWines();
    },
    recomEvent() {
      return getters.recomEvent();
    },
    recomArchive() {
      return getters.recomArchive();
    },
    recomBackVintages() {
      return getters.recomBackVintages();
    },
    isLoading() {
      return getters.isLoading();
    },
  },
  methods: {
    handleFilterChange(value) {
      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();

      try {
        actions.countKeywordChars(value);
        actions.getSuggRecomSearch(value, this.abortController);
      } catch (err) {
        if (err.name === "AbortError") {
          console.log("Aborted search request:", err.message);
        } else {
          console.error("Unexpected error:", err);
        }
      }
    },
    registerGA(url, searchTerm) {
      if (window.ga && ga.create) {
        ga("send", "page", searchTerm);
      }
    },
    getDefaultSugg() {
      actions.getDefaultSugg();
    },
  },
  created() {
    // Initialize the debounced function
    this.debouncedFilterChange = debounce(this.handleFilterChange, 300); // Wait 300ms after typing
  },
  mounted() {
    this.getDefaultSugg();
  },
};


</script>
